import { h } from "./../../utils/createElement";
import { __extends } from "tslib";
import * as React from 'react';
import { consumeTheme } from '../../utils/theme';
import { ActionSheet } from '../ActionSheet';
import { getActionSheetConfig } from './utils';
var Surroundings = (function (_super) {
    __extends(Surroundings, _super);
    function Surroundings() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleClickAction = function (id) {
            var _a;
            var _b = _this.props, currentIndex = _b.currentIndex, onActionSheetClose = _b.onActionSheetClose;
            var actionSheetConfig = _this.actionSheetConfig;
            if (!actionSheetConfig) {
                return;
            }
            var targetConfig = actionSheetConfig.find(function (config) { return config.id === id; });
            if (!targetConfig) {
                return;
            }
            (_a = targetConfig.onClick) === null || _a === void 0 ? void 0 : _a.call(targetConfig, currentIndex);
            onActionSheetClose();
        };
        _this.themedRender = function (classNames) {
            var _a = _this.props, prefixCls = _a.prefixCls, onClose = _a.onClose, currentIndex = _a.currentIndex, images = _a.images, showPageNumber = _a.showPageNumber, isActionSheetVisible = _a.isActionSheetVisible, isWidgetsVisible = _a.isWidgetsVisible, showCloseButton = _a.showCloseButton, renderWidgets = _a.renderWidgets, onActionSheetClose = _a.onActionSheetClose;
            var pageNumberClasses = classNames(prefixCls + "-page-number", prefixCls + "-page-number-" + (isWidgetsVisible ? 'visible' : 'hidden'));
            var widgetsContainerClasses = classNames(prefixCls + "-widgets-container", prefixCls + "-widgets-container-" + (isWidgetsVisible ? 'visible' : 'hidden'));
            var closeButtonClass = classNames(prefixCls + "-close-button");
            var actionSheetConfig = _this.actionSheetConfig;
            return (h(React.Fragment, null,
                showPageNumber && images.length > 1 && h("div", { className: pageNumberClasses },
                    currentIndex + 1,
                    "/",
                    images.length),
                showCloseButton && h("div", { className: closeButtonClass, onClick: onClose }),
                h("div", { className: widgetsContainerClasses }, !actionSheetConfig ? renderWidgets(currentIndex) : ''),
                actionSheetConfig && actionSheetConfig.length > 0 && h(ActionSheet, { visible: isActionSheetVisible, onClickAction: _this.handleClickAction, onCancel: onActionSheetClose, options: actionSheetConfig.map(function (config) { return ({
                        id: config.id,
                        disabled: config.disabled || false,
                    }); }) })));
        };
        return _this;
    }
    Object.defineProperty(Surroundings.prototype, "actionSheetConfig", {
        get: function () {
            var _a = this.props, images = _a.images, actionSheetConfig = _a.actionSheetConfig;
            return getActionSheetConfig(images, actionSheetConfig);
        },
        enumerable: false,
        configurable: true
    });
    Surroundings.prototype.render = function () {
        return consumeTheme(this.themedRender);
    };
    return Surroundings;
}(React.Component));
export default Surroundings;
Surroundings.defaultProps = {
    prefixCls: 'dui-m-preview',
    renderWidgets: function () { return null; },
};
